/**
 * Transaction references: "<prefix>-<year>-<number>", e.g. SA-2026-12363. The
 * year is the business date's year and numbers come from per-table sequences
 * that are never reset, so a reference stays unique across years and the
 * archive (fuel.md section 12).
 */
export const REFERENCE_PREFIXES = {
    REVOLVING_BALANCE: 'RB',
    PURCHASE: 'PU',
    SALE: 'SA',
    DEBT_MOVEMENT: 'DM',
    PAYMENT: 'PA',
    RECEIPT: 'RC',
    CLOSE: 'CL',
};
export function formatReference(family, year, number) {
    if (!Number.isInteger(year) || year < 2000 || year > 9999) {
        throw new RangeError(`A reference year must be a four-digit year, got ${year}`);
    }
    if (!Number.isInteger(number) || number <= 0) {
        throw new RangeError(`A transaction number must be a positive integer, got ${number}`);
    }
    return `${REFERENCE_PREFIXES[family]}-${year}-${number}`;
}
/** The reference of a transaction filed under a business date (YYYY-MM-DD). */
export function referenceFor(family, businessDate, number) {
    return formatReference(family, Number(businessDate.slice(0, 4)), number);
}
const PREFIX_TO_FAMILY = new Map(Object.entries(REFERENCE_PREFIXES).map(([family, prefix]) => [prefix, family]));
export function parseReference(reference) {
    const match = /^([A-Z]{2})-(\d{4})-([1-9]\d*)$/.exec(reference.trim().toUpperCase());
    if (!match)
        return null;
    const family = PREFIX_TO_FAMILY.get(match[1]);
    if (!family)
        return null;
    return { family, year: Number(match[2]), number: Number(match[3]) };
}
/** The Customers movement reference of one debt movement revision (fuel.md section 8). */
export function customerMovementReference(debtReference, revision) {
    if (!Number.isInteger(revision) || revision <= 0) {
        throw new RangeError(`A revision must be a positive integer, got ${revision}`);
    }
    return `${debtReference}-${revision}`;
}
/**
 * The reference inside text typed or scanned into the lookup field (fuel.md
 * section 4.3): trims whitespace and the line break a keyboard-wedge scanner
 * appends, upper-cases, and returns null unless the result is a reference of
 * the shared pattern. The PDA receipt QR holds exactly the reference.
 */
export function normalizeReferenceCode(raw) {
    const code = raw.trim().toUpperCase();
    return parseReference(code) ? code : null;
}
//# sourceMappingURL=reference.js.map